import { useState } from "react";
import "swiper/css";
import "swiper/css/navigation";

import ContactSection from "../components/Contact";

//@ts-ignore
import heroVideo from "../assets/images/hero-home.mp4";

//@ts-ignore
import contactHero from "../assets/images/contact-hero.jpg";
//@ts-ignore
import showroomBg from "../assets/images/showroom-hero.jpg";

import ServicesGrid from "../components/ServicesGrid";

//@ts-ignore
import logoLoxone from "../assets/images/logo-loxone.png";
import Projects from "../components/Projects";
import { useSiteSettings } from "../hooks/useSiteSettings";
import Marquee from "react-fast-marquee";

export default function MainContent() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const { settings, loading, error } = useSiteSettings("Homepage");

  console.log(settings);

  const scrollableText = settings.homepage_scrollable_texts; //a string with ; separator
  const scrollableTextArray = scrollableText
    ? scrollableText.split(";").map((text: string) => text.trim())
    : [];

  //remove any empty strings from the array
  const filteredScrollableTextArray = scrollableTextArray.filter(
    (text: string) => text !== "",
  );

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero"
        // style={{
        //   backgroundImage: `url(${hero})`,
        // }}
      >
        <div className="shade"></div>
        <video className="hero-video" autoPlay muted loop playsInline>
          <source src={heroVideo} type="video/mp4" />
        </video>
        <div className="inner">
          <h1>{loading ? "" : settings.homepage_hero_title}</h1>
          <h4>
            {loading
              ? ""
              : settings.homepage_hero_subtitle || "Automation Without Limits!"}
          </h4>
          <p>
            Suntem partenerul tău oficial Loxone în România. Cu{" "}
            <strong>peste 20 de ani de experiență</strong>, transformăm orice
            spațiu într-un mediu inteligent, intuitiv și eficient.
          </p>
          <div className="loxone-logo">
            <img src={logoLoxone} alt="Loxone Logo" />
          </div>
          <a className="special-button" href="#contact">
            Solicită o ofertă personalizată
          </a>
        </div>
      </section>

      <div className="main-content">
        {/* Scrolling Bar */}
        <div className="scrolling-bar">
          <Marquee
            className="scrolling-bar-marquee"
            gradient={false}
            speed={40}
            pauseOnHover
            autoFill
          >
            {filteredScrollableTextArray.map((text: string, index: number) => (
              <span
                className="text"
                style={{ marginRight: 32 }}
                key={`scroll-text-${index}`}
              >
                {text}
              </span>
            ))}
          </Marquee>
          <div className="fade"></div>
        </div>

        <div
          className="an-section spacing-small bg-light-primary mt0"
          id="services"
        >
          <div className="an-title">
            <h2>SERVICII OFERITE</h2>
            <p>
              Ne ocupăm de tot, de la idee la realitate: Gestionăm întregul
              proces, de la <strong>proiectare</strong> și{" "}
              <strong>programare</strong> până la{" "}
              <strong>montajul final</strong>, pentru a-ți livra o soluție
              inteligentă la cheie, perfect funcțională.
            </p>
          </div>
        </div>

        <div id="servicii">
          <ServicesGrid />
        </div>

        {/* <div
          className="an-section spacing-small bg-light-primary mt0"
          id="projects"
        >
          <div className="an-title">
            <h2>INSPIRAȚIE DIN PROIECTELE NOASTRE</h2>
            <p>
              Fiecare client are o viziune unică. Misiunea noastră este să o
              transformăm intr-un sistem inteligent, perfect funcțional.
              Explorați portofoliul nostru pentru a vedea cum viziunile altor
              clienți au prins viață, de la locuințe private la proiecte
              comerciale complexe.
            </p>
          </div>
        </div>
        <Projects />

        <div className="an-section" style={{ marginTop: -24 }} id="projects">
          <div className="an-content flex center">
            <a className="special-button large" href="#">
              VEZI MAI MULTE PROIECTE
            </a>
          </div>
        </div> */}

        <div id="showroom">
          <div
            className="bg-section"
            style={{ backgroundImage: `url(${showroomBg})` }}
          ></div>
          <div className="shade"></div>
          <div className="an-section">
            <div className="an-content flex center more-left">
              <div className="an-col w-6 text">
                <h1>EXPERIMENTEAZĂ TEHNOLOGIA LOXONE ÎN SHOWROOM-UL NOSTRU</h1>
                <p>
                  Ești curios cum funcționează o casă inteligentă? Vino în{" "}
                  <strong>ModelHome Loxone</strong>,{" "}
                  <strong>primul showroom de acest fel din Cluj-Napoca</strong>{" "}
                  și vezi cu ochii tăi.
                </p>
                <a className="special-button" href="#contact">
                  Programează o vizită acum
                </a>
              </div>
              <div className="an-col w-6 blank"></div>
            </div>
          </div>
        </div>
        <div
          id="contact"
          style={{
            backgroundImage: `url(${contactHero})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="contact-shade"></div>
          <ContactSection />
        </div>
      </div>
    </>
  );
}
